<template>
    <SideBar>
        <div class="section-favourite">
            <template v-if="step === 1">
                <h1 class="section-favourite__title t-transform-cap">
                    {{ getTranslatedText("my numbers") }}
                    <img
                        src="@/assets/images/common/vector-down.png"
                        @click="onShowBottomMenuList"
                    />
                </h1>

                <TabCommon
                    :tabs="tabs"
                    :is-pos-device="true"
                    :class-container="'section-favourite__favourite-custom'"
                >
                    <template slot="favourite-Number">
                        <NoEmpty
                            v-if="listFavourite.length === 0"
                            :text="getTranslatedText('no data')"
                        />
                        <div
                            v-else
                            v-for="(item, index) in listFavourite"
                            :key="index"
                        >
                            <NumberFavourite 
                                :balls="item.balls"
                                :title="item.title"
                                :indexItem="index"
                                :showDownload="false"
                                :maxiumBlue="maxiumBlue"
                                :maxiumGreen="maxiumGreen"
                                :minimumBall="minimumBall"
                                @onClickEdit="onClickEditBall"
                                @onClickDelete="onClickConfirmModal"
                            />
                        </div>
                        
                        <div class="section-favourite__action-add">
                            <ButtonCustom
                                typeBtn="button"
                                type="default"
                                text="+ Add Favourite"
                                @onClickButton="onClickAddFavourite"
                            />
                        </div>
                    </template>
                    <div slot="past-combinations" class="past-combinations">
                        <NoEmpty
                            v-if="listPastCombinations.length === 0"
                            :text="getTranslatedText('no data')"
                        />
                        <div
                            v-else
                            v-for="(item, index) in listPastCombinations"
                            :key="index"
                        >
                            <NumberFavourite
                                :raffle_id="item.raffle_id" 
                                :is-past="true"
                                :showDownload="true"
                                :isDownload=" 
                                    item.raffle_id ? true : false
                                "
                                :link_certificate="item.link_certificate"
                                :balls="item.balls"
                                :dateBall="item.date"
                                :indexItem="index"
                                :isAction="false"
                                :maxiumBlue="maxiumBlue"
                                :maxiumGreen="maxiumGreen"
                                :minimumBall="minimumBall"
                                :isShowIconArrow="true"
                                :userInfo="userInfo"
                                @showToast="showToast"
                                @onClickIconArrow="onClickIconArrow(item)"
                            />
                        </div>
                        <div v-if="totalPastCombinations > 0" class="section-favourite__pagination">
                            <div class="section-favourite__pagination__count">
                                {{pageCountPastCombinations}}/{{totalPastCombinations}}
                            </div>
                            <b-pagination
                                v-model="currentPastCombinations"
                                :total-rows="totalPastCombinations"
                                :per-page="perPagePagination"
                            ></b-pagination> 
                        </div>
                    </div>
                </TabCommon>
            </template>
            <template v-if="step === 2"
                ><AddFavourite
                    @onGoBack="onGoBack"
                    @onSubmit="onSubmitAdd"
                    @showToast="showToast"
            /></template>
            <template v-if="step === 3">
                <EditFavourite
                    :dataDetail="dataDetail"
                    @onGoBack="onGoBack"
                    @onSubmit="onSubmitEdit"
                    @showToast="showToast"
                />
            </template>

            <vue-bottom-sheet
                max-height="90%"
                ref="bottomHistoryNumber"
                class="bottom-sheet__container-custom"
            >
                <BottomSheet
                    v-if="dataDetail !== null"
                    title="past number"
                    classBtn="bottom-sheet-favourite__button btn-success"
                    type="primary"
                    text="Download Green Certificate"
                    @onClickSheet="handleDownload"
                    :isLoadingButton="isLoadingButton"
                    :isHiddenBtn="dataDetail.isShowButton ? false : true"
                >
                    <template slot="body-sheet" v-if="dataDetail !== null">
                        <div class="bottom-sheet-favourite" :style="cssProps">
                            <h1
                                class="bottom-sheet-favourite__title-ball t-transform-cap"
                            >
                                {{ getTranslatedText("your numbers") }}
                            </h1>
                            <div class="bottom-sheet-favourite__list-ball">
                                <div
                                    :class="`bottom-sheet-favourite__item-ball ${renderClass(
                                        number,
                                        index
                                    )}`"
                                    v-for="(number, index) in dataDetail.balls"
                                    :key="index"
                                >
                                    <div
                                        class="bottom-sheet-favourite__box-ball"
                                    >
                                        <div
                                            class="bottom-sheet-favourite__number" 
                                        >
                                            {{ renderNumberLocale(number) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-if="raffle_id !== ''">
                            <p
                                class="bottom-sheet-favourite__raffle-id t-transform-cap"
                            >
                                <span
                                    >{{ getTranslatedText("raffle id") }}
                                </span>
                                {{ dataDetail.raffle_id || getTranslatedText("Pending Generation") }}
                            </p>
                            <p class="bottom-sheet-favourite__date">
                                {{ getTranslatedText('draw date') }}: {{ dataDetail.date }}
                            </p>
                            <div class="bottom-sheet-favourite__download__icon">
                                <b-spinner v-if="isLoadingButton" variant="success" />
                                <img v-if="userInfo.phone !== '' && dataDetail.link_certificate" @click="!isLoadingButton && downloadFileSendToLink(dataDetail.raffle_id, 'phone')" src="@/assets/images/common/icon-sms.png" />
                                <img  v-if="userInfo.email !== '' && dataDetail.link_certificate" @click="!isLoadingButton && downloadFileSendToLink(dataDetail.raffle_id, 'email')" src="@/assets/images/common/icon-email.png" />
                            </div>
                            <p v-if="!dataDetail.isShowButton"  class="bottom-sheet-favourite__generating">{{ getTranslatedText('generating certificate') }}</p>
                        </template>
                    </template>
                </BottomSheet>
            </vue-bottom-sheet>

            <vue-bottom-sheet max-height="90%" ref="bottomMenuList">
                <BottomSheet :isHiddenBtn="true">
                    <template slot="body-sheet">
                        <ul class="bottom-sheet-list-navigation__menu-list">
                            <li
                                v-for="(item, index) in listMenuNavigation"
                                :key="index"
                                v-show="item.isShow"
                                class="bottom-sheet-list-navigation__menu-item"
                            >
                                <div
                                    @click="handleClickRedirect(item)"
                                    class="bottom-sheet-list-navigation__menu-item-content t-transform-cap"
                                >
                                    <img
                                        class="user-avatar"
                                        :src="
                                            require(`@/assets/images/navigation/${item.icon}`)
                                        "
                                        :alt="item.icon"
                                    />
                                    {{ getTranslatedText(item.title) }}
                                </div>
                            </li>
                        </ul>
                    </template>
                </BottomSheet>
            </vue-bottom-sheet>

            <ConfirmModal
                id="modal-confirm-remove-favourite"
                :title="getTranslatedText('delete Favourite Number?')"
                :description="
                    getTranslatedText(
                        'once the number is deleted cannot be recovered. Do you want to delete it?'
                    )
                "
                :textBtnCancel="getTranslatedText('cancel')"
                :textBtnDelete="getTranslatedText('delete')"
                :isLoadingButton="isLoadingButtonConfirm"
                :showBtnCancel="true"
                @onCancelModal="onCancelRemove"
                @onDelete="onClickDeleteBall"
            />
            <Toast :title="toastData.message" :type="toastData.type" />
        </div>
    </SideBar>
</template>
<script>
import { getUserInfo } from "@/services/axios";
import { listMenuNavigation } from "@/resources/listNavigation";
import {
    isArrayEmpty,
    isStrEmpty,
    redirectPathApp,
    renderClassBall,
    renderLocaleNumber,
} from "@/components/common/utils";

import LanguageMixin from "@/mixins/language/language-mixin";
import RouterMixin from "@/mixins/router/router-mixin"

import toolService from "@/services/tool.service";
import FavouriteService from "@/services/favourite.service";

import NumberFavourite from "@/components/common/number-favourite/index.vue";
import TabCommon from "@/components/common/tabs/tabs-swift.vue";
import BottomSheet from "@/components/common/bottom-sheet";
import ButtonCustom from "@/components/common/button";
import ConfirmModal from "@/components/common/confirm";
import NoEmpty from "@/components/common/no-empty";

import AddFavourite from "@/views/mobile/favourite/add";
import EditFavourite from "@/views/mobile/favourite/edit";
import SideBar from "@/components/common/sidebar/SideBar";
import Toast from "@/components/common/toast/Toast.vue";
import moment from "moment";

export default {
    mixins: [LanguageMixin, RouterMixin],
    components: {
        TabCommon,
        NumberFavourite,
        ButtonCustom,
        AddFavourite,
        EditFavourite,
        BottomSheet,
        ConfirmModal,
        NoEmpty,
        SideBar,
        Toast,
    },
    data() {
        return {
            toastData: {
                message: "",
                type: "success",
            },
            raffle_id: "",
            step: 1,
            maxiumBlue: 0,
            maxiumGreen: 0,
            minimumBall: 0,
            dataDetail: null,
            indexEdit: -1,
            pageHistory: "1",
            isLoadingButton: false,
            isLoadingButtonConfirm: false,
            cssProps: {
                backgroundImage: `url(${require("@/assets/images/tickets/background-favourite.png")})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            },
            listMenuNavigation,
            listPastCombinations: [],
            listFavourite: [],
            totalPastCombinations: 0,
            currentPastCombinations: 1,
            perPagePagination: 20,
            userInfo: null,
            tabs: [
                {
                    title: this.getTranslatedText("Past Combinations"),
                    isShow: false,
                    nameSlot: "past-combinations",
                },
                {
                    title: this.getTranslatedText("Favourite Numbers"),
                    isShow: false,
                    nameSlot: "favourite-Number",
                },
            ],
        };
    },
    created() {
        this.fetchDataValidateBall();
        this.fetdataListFavourite();
        this.fetdataListPasrCombinations();
    },
    watch: {
        currentPastCombinations(val) {
            if(val) {
                this.currentPastCombinations = val;
                this.fetdataListPasrCombinations();
            }
        }
    },
    methods: {
        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
            this.$bvToast.show("my-toast");
        },
        async fetchDataValidateBall() {
            try {
                const resp = await toolService.getValidateTicket();

                this.listNumber = new Array(resp.quatityNumber);

                this.maxiumBlue = resp.maxiumBlue;
                this.maxiumGreen = resp.maxiumGreen;
                this.minimumBall = resp.minMaxTickets[0];
            } catch (err) {
                console.log(err, "err");
            }
        },

        async fetdataListFavourite() {
            try {
                let info = getUserInfo() ? JSON.parse(getUserInfo()) : "";

                let param = {
                    user_id: info?.id,
                };
                this.userInfo = info
                const resp = await FavouriteService.getList(param);

                if (resp.status === 200 && !isArrayEmpty(resp.data)) {
                    let listFavourite = resp.data.map((item) => {
                        let balls = !isArrayEmpty(item.favourite_number[0])
                            ? item.favourite_number[0].map((number) =>
                                  parseInt(number)
                              )
                            : [];

                        return {
                            id: item.id,
                            title: item.favourite_name,
                            balls,
                        };
                    });
                    listFavourite = listFavourite.sort(
                        (a, b) => Number(a.id) - Number(b.id)
                    );
                    let user_info = JSON.parse(localStorage.getItem("user_info"));
                    this.userInfo = user_info
                    this.listFavourite = listFavourite;
                }
            } catch (err) {
                console.log(err, "err");
            }
        },

        async fetdataListPasrCombinations() {
            try {
                const resp = await FavouriteService.getListHistory(this.currentPastCombinations); 

                if (resp.status === 200 && !isArrayEmpty(resp.data)) {
                    let locale = this.$store.state.isRtl ? "ar" : "en";
                    moment.locale(locale)

                    let listPastCombinations = resp.data.map((item) => {
                        let balls = [];
                        if (!isArrayEmpty(item.bets.bets)) {
                            item.bets.bets.map((x) => {
                                balls = balls.concat(x);
                            }); 
                        }
                        
                        let date = moment(item.draw_date).format("DD/MM/YYYY");

                        return {
                            id: item.id,
                            date,
                            reference: item.reference,
                            raffle_id: item.raffle_id,
                            link_certificate: item.link_certificate,
                            balls,
                        };
                    });
                    this.pageCountPastCombinations = this.currentPastCombinations * this.perPagePagination;
                    if(this.pageCountPastCombinations > resp.total) {
                        this.pageCountPastCombinations = resp.total;
                    }

                    this.totalPastCombinations = resp.total
                    this.listPastCombinations = listPastCombinations;
                }
            } catch (err) {
                console.log(err, "err");
            }
        },

        onClickAddFavourite() {
            this.step = 2;
        },

        onShowBottomMenuList() {
            this.$refs.bottomMenuList.open();
        },

        // action
        onClickEditBall(index) {
            this.dataDetail = { ...this.listFavourite[index] };
            this.indexEdit = index;
            this.step = 3;
        },

        // remove

        onClickConfirmModal(index) {
            this.indexEdit = index;
            this.$bvModal.show("modal-confirm-remove-favourite");
        },

        onCancelRemove() {
            this.$bvModal.hide("modal-confirm-remove-favourite");
            this.indexEdit = -1;
        },

        async onClickDeleteBall() {
            this.isLoadingButtonConfirm = true;
            if (this.indexEdit !== -1) {
                let param = {
                    id: this.listFavourite[this.indexEdit].id,
                };
                try {
                    const resp = await FavouriteService.remove(param);
                    if (resp.status === 200) {
                        this.listFavourite.splice(this.indexEdit, 1);
                        this.isLoadingButtonConfirm = false;
                        this.$bvModal.hide("modal-confirm-remove-favourite");
                        this.showToast(
                            this.getTranslatedText(resp.message),
                            "success"
                        );
                    }
                } catch (err) {
                    console.log(err, "err");
                }
            }
        },

        onGoBack() {
            this.step = 1;
            this.dataDetail = null;
        },

        // sheet bottom history number
        onClickIconArrow(item) {
            this.raffle_id = !isStrEmpty(item.link_certificate) ? true : false;
            item['isShowButton'] = !isStrEmpty(item.link_certificate) ? true : false
            this.dataDetail = { ...item };
            this.$refs.bottomHistoryNumber.open();
        },

        handleDownload() {
            this.isLoadingButton = true
            window.open(this.dataDetail.link_certificate, "_blank")

            setTimeout(() => {
                this.isLoadingButton = false
            }, 2000);
        },
        // action step add
        onSubmitAdd(item) {
            let payload = { ...item };
            delete payload.message;
            this.listFavourite.push({ ...payload });
            this.step = 1;
            this.showToast(this.getTranslatedText(item.message), "success");
        },

        // action step edit
        onSubmitEdit(item) {
            if (this.indexEdit !== -1) {
                let payload = { ...item };
                delete payload.message;

                this.listFavourite[this.indexEdit] = payload;
                this.indexEdit = -1;
                this.dataDetail = null;
                this.step = 1;
                this.showToast(this.getTranslatedText(item.message), "success");
            }
        },

        renderClass(number, index) {
            return renderClassBall(
                number,
                index,
                this.minimumBall,
                this.maxiumBlue,
                this.maxiumGreen
            );
        },

        handleClickRedirect(item) {
            if (this.$store.state.is_app && item.isRedirect) {
                redirectPathApp(item.url);
            } else {
                this.routerPush(item.url);
            }
        },

          renderNumberLocale(number) {
            return renderLocaleNumber(number);
        },

         async downloadFileSendToLink(code, type) {
            try {
                this.isLoadingButton = true
                const resp = type === 'email' ? await FavouriteService.downloadCertificateSendToMail(code) : await FavouriteService.downloadCertificateSendToPhone(code)
                console.log(resp)
                if(resp.status === 200) {
                    this.showToast(this.getTranslatedText(resp.message), "success")
                    this.isLoadingButton = false
                } else {
                    this.showToast(this.getTranslatedText(resp.message), "error")
                    this.isLoadingButton = false
                }
            } catch (error) {
                this.isLoadingButton = false
                console.log(error)
            }
        }
    },
};
</script>

<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/favourite/_favourite.scss"
/>
